<!-- Chat Widget — só monta se o admin configurou e ativou explicitamente -->
<template>
  <div />
</template>

<script>
const STORAGE_KEY_SRC = 'chatSupportSrc'
const STORAGE_KEY_ON  = 'chatSupportEnabled'
const CONFIG_EVENT    = 'deskiq-config-changed'   // evento disparado na mesma aba

// Tamanhos do iframe
const SIZE_CLOSED = { width: '96px',  height: '96px'  }   // cobre só o FAB
const SIZE_OPEN   = { width: '440px', height: '640px' }   // chat completo aberto

export default {
  name: 'ChatWidget',

  mounted() {
    this.initWidget()

    // 'storage' só dispara em OUTRAS abas — usamos um CustomEvent para a mesma aba
    window.addEventListener(CONFIG_EVENT, this.onConfigChanged)
    // Mantemos 'storage' também para sincronizar entre abas diferentes
    window.addEventListener('storage', this.onStorageChange)
  },

  beforeDestroy() {
    window.removeEventListener(CONFIG_EVENT, this.onConfigChanged)
    window.removeEventListener('storage', this.onStorageChange)
    this._msgHandler && window.removeEventListener('message', this._msgHandler)
    this.removeWidget()
  },

  methods: {
    getUserData() {
      try { return JSON.parse(localStorage.getItem('userData') || '{}') } catch { return {} }
    },

    injectUserData(src) {
      const u = this.getUserData()
      const email = encodeURIComponent(u.user_email || u.email || '')
      const id    = encodeURIComponent(u.id || '')
      const name  = encodeURIComponent(u.user_name || u.name || '')
      return src
        // Placeholders internos do sistema
        .replace(/USER_EMAIL/g,   email)
        .replace(/CLIENT_ID/g,    id)
        .replace(/PRODUCT_NAME/g, encodeURIComponent('VSLBOOSTER'))
        .replace(/USER_NAME/g,    name)
        // Placeholders {{...}} nos parâmetros da URL (colados pelo usuário)
        .replace(/([&?]email=)\{\{[^}]*\}\}/gi,      '$1' + email)
        .replace(/([&?]clientId=)\{\{[^}]*\}\}/gi,    '$1' + id)
        .replace(/([&?]userName=)\{\{[^}]*\}\}/gi,    '$1' + name)
        // Versões URL-encoded de {{ e }}
        .replace(/([&?]email=)%7B%7B[^%]*%7D%7D/gi,   '$1' + email)
        .replace(/([&?]clientId=)%7B%7B[^%]*%7D%7D/gi, '$1' + id)
        .replace(/([&?]userName=)%7B%7B[^%]*%7D%7D/gi, '$1' + name)
    },

    initWidget() {
      this.removeWidget()

      const customSrc = localStorage.getItem(STORAGE_KEY_SRC)
      const isEnabled = localStorage.getItem(STORAGE_KEY_ON) === 'true'
      const mode = localStorage.getItem('chatSupportMode') || 'iframe'

      if (!customSrc || !isEnabled) return

      if (mode === 'loader') {
        this.mountLoader(customSrc)
      } else {
        const src = this.injectUserData(customSrc)
        this.mountIframe(src)
      }
    },

    mountIframe(src) {
      if (document.getElementById('deskiq-widget')) return

      const iframe = document.createElement('iframe')
      iframe.src = src
      iframe.id = 'deskiq-widget'
      iframe.allow = 'clipboard-write'
      iframe.setAttribute('allowtransparency', 'true')
      iframe.setAttribute('title', 'DeskIQ Chat')

      // Começa pequeno — cobre apenas o FAB no canto inferior direito.
      // pointer-events: auto permite clicar no botão de chat.
      const css = (p, v) => iframe.style.setProperty(p, v, 'important')
      const resize = open => {
        css('position',       'fixed')
        css('bottom',         '0')
        css('right',          '0')
        css('left',           'auto')
        css('top',            'auto')
        css('border',         '0')
        css('background',     'transparent')
        css('z-index',        '2147483647')
        css('pointer-events', 'auto')
        css('max-width',      '100vw')
        css('max-height',     '100vh')
        css('transition',     'width .25s ease, height .25s ease')
        css('width',  open ? SIZE_OPEN.width  : SIZE_CLOSED.width)
        css('height', open ? SIZE_OPEN.height : SIZE_CLOSED.height)
      }

      resize(false)

      // Ouve mensagens do WidgetEmbed para expandir/recolher
      this._msgHandler = e => {
        const fr = document.getElementById('deskiq-widget')
        if (!fr) return
        if (e.data === 'deskiq-widget-active')   resize(true)
        if (e.data === 'deskiq-widget-inactive')  resize(false)
      }

      window.addEventListener('message', this._msgHandler)
      document.body.appendChild(iframe)
    },

    mountLoader(src) {
      if (document.getElementById('deskiq-widget')) return

      const script = document.createElement('script')
      script.src = src
      script.id = 'deskiq-widget'

      const attrs = JSON.parse(localStorage.getItem('chatSupportLoaderAttrs') || '{}')
      const u = this.getUserData()

      Object.entries(attrs).forEach(([key, val]) => {
        let resolved = val
          .replace(/USER_EMAIL/gi, u.user_email || u.email || '')
          .replace(/CLIENT_ID/gi, String(u.id || ''))
          .replace(/PRODUCT_NAME|PRODUCT/gi, 'VSLBOOSTER')
          .replace(/USER_NAME/gi, u.user_name || u.name || '')
        script.setAttribute('data-' + key, resolved)
      })

      document.body.appendChild(script)
    },

    removeWidget() {
      const el = document.getElementById('deskiq-widget')
      if (el) el.remove()
      if (this._msgHandler) {
        window.removeEventListener('message', this._msgHandler)
        this._msgHandler = null
      }
    },

    // Chamado quando config muda na MESMA aba (CustomEvent)
    onConfigChanged() {
      this.initWidget()
    },

    // Chamado quando config muda em OUTRA aba (storage event)
    onStorageChange(e) {
      if (e.key === STORAGE_KEY_SRC || e.key === STORAGE_KEY_ON) {
        this.initWidget()
      }
    },
  },
}
</script>
